import * as React from "react";
import { Col, Form, Input, Radio, Row, DatePicker, Typography } from "antd";
import dayjs from "dayjs";
import { UploadOutlined } from "@ant-design/icons";

import FormHeader from "../FormHeader";
import IconButton from "../../ui/IconButton";
import { DateSelectionType, DateValue, CurrencyPlaceholderName } from "../../../types/newLinkBuilder";

interface DateFormProps {
    dateValue: DateValue;
    setDateValue: (value: DateValue) => void;
    handlePlaceholder: (name: CurrencyPlaceholderName) => void;
}

const DateForm: React.FC<DateFormProps> = ({ dateValue, setDateValue, handlePlaceholder }) => {
    const handleDateChange = (field: keyof DateValue, value: string) => {
        setDateValue({ ...dateValue, [field]: value });
    }

    return (
        <>
            <FormHeader title="Date" />
            <Typography.Title level={5} style={{ textAlign: 'left', paddingBottom: '10px' }}>
                <u>As-of-Date</u>
            </Typography.Title>
            <Form.Item name="date">
                <Radio.Group
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                    }}
                    options={[{
                        value: DateSelectionType.Date,
                        label: (
                            <Row
                                align={"middle"}
                            >
                                <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <span>Date</span>
                                </Col>

                                <Col span={18} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <DatePicker
                                        format="MM/DD/YYYY"
                                        placeholder="Select a date"
                                        maxDate={dayjs()}
                                        disabled={dateValue.selected === DateSelectionType.CellReference}
                                        style={{ width: "100%" }}
                                        value={dateValue.date ? dayjs(dateValue.date) : null}
                                        onChange={(value) => handleDateChange("date", value ? dayjs(value).toISOString() : "")}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Col>
                            </Row>
                        )
                    }, {
                        value: DateSelectionType.CellReference,
                        label: (
                            <Row
                                align={"middle"}
                            >
                                <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <span>Cell Reference</span>
                                </Col>

                                <Col span={16} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <Input
                                        placeholder="Cell Reference"
                                        disabled={dateValue.selected === DateSelectionType.Date}
                                        value={dateValue.dateCellReference}
                                        onChange={(e) => handleDateChange("dateCellReference", e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </Col>

                                <Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
                                    <IconButton
                                        disabled={dateValue.selected === DateSelectionType.Date}
                                        icon={<UploadOutlined />}
                                        onClick={() => handlePlaceholder(CurrencyPlaceholderName.DateCellReference)}
                                    />
                                </Col>
                            </Row>
                        )
                    }]}
                />
            </Form.Item>
        </>
    );
};

export default DateForm;
